import { toast, ToastContainer } from 'react-toastify';
import type { ToastOptions, ToastContainerProps, ToastPromiseParams } from './types';

const Toast = ({
  position = 'top-center',
  autoClose = 5000,
  hideProgressBar = false,
  newestOnTop = false,
  closeOnClick = true,
  rtl = false,
  pauseOnFocusLoss = true,
  draggable = true,
  pauseOnHover = true,
  theme = 'light',
  ...rest
}: ToastContainerProps) => (
  <ToastContainer
    position={position}
    autoClose={autoClose}
    hideProgressBar={hideProgressBar}
    newestOnTop={newestOnTop}
    closeOnClick={closeOnClick}
    rtl={rtl}
    pauseOnFocusLoss={pauseOnFocusLoss}
    draggable={draggable}
    pauseOnHover={pauseOnHover}
    theme={theme}
    toastStyle={{
      fontFamily: 'Roboto',
      zIndex: '1300 !important',
    }}
    {...rest}
  />
);

export const displayToast = (message: string, options?: ToastOptions) => {
  toast(message, options);
};

export const displayErrorToast = (message: string, options?: ToastOptions) => {
  toast.error(message, { ...options, toastId: message });
};

export const displayInfoToast = (message: string, options?: ToastOptions) => {
  toast.info(message, { ...options, toastId: message });
};

export const displayPromiseToast = async (promiseFunc: () => Promise<any>, options: ToastPromiseParams) => {
  await toast.promise(promiseFunc, options);
};

export const dismissToast = (_toastId: string) => {
  toast.dismiss(_toastId);
};

export default Toast;
